"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActionCreators = exports.UserActionTypes = void 0;
var UserActionTypes;
(function (UserActionTypes) {
    UserActionTypes["Login"] = "User.Login";
    UserActionTypes["Logout"] = "User.Logout";
    UserActionTypes["Register"] = "User.Register";
    UserActionTypes["UpdateProfile"] = "User.UpdateProfile";
    UserActionTypes["UpdateAuth"] = "User.UpdateAuth";
    UserActionTypes["Load"] = "User.Load";
    UserActionTypes["Unload"] = "User.Unload";
    UserActionTypes["Registered"] = "User.Registered";
    UserActionTypes["AuthEnabled"] = "User.AuthEnabled";
})(UserActionTypes = exports.UserActionTypes || (exports.UserActionTypes = {}));
class UserActionCreators {
}
exports.UserActionCreators = UserActionCreators;
UserActionCreators.load = (user) => ({
    type: UserActionTypes.Load,
    user
});
UserActionCreators.unload = () => ({
    type: UserActionTypes.Unload
});
UserActionCreators.updateAuth = (secret) => ({
    type: UserActionTypes.UpdateAuth,
    secret
});
UserActionCreators.registered = () => ({
    type: UserActionTypes.Registered
});
UserActionCreators.authEnabled = (authEnabled) => ({
    type: UserActionTypes.AuthEnabled,
    authEnabled
});
UserActionCreators.updateProfile = (user) => ({
    type: UserActionTypes.UpdateProfile,
    user
});
UserActionCreators.login = (login) => ({
    type: UserActionTypes.Login,
    login
});
UserActionCreators.logout = () => ({
    type: UserActionTypes.Logout,
});
UserActionCreators.register = (register) => ({
    type: UserActionTypes.Register,
    register
});
//# sourceMappingURL=user.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/actions/user.js
// module id = 111
// module chunks = 0